import React from 'react';
import BaseComponent from 'Core/components/BaseComponent';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import * as actions from './actions';
import SelectInput from "Core/components/input/SelectInput";
import {find, omit} from 'lodash';
import Label from 'Core/components/display/Label';
import {getString, getStringForDisplay} from 'Core/helpers/data';

class IoTimezoneSelectInput extends BaseComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			options: [],
		}
	}
	
	/** @inheritDoc */
	async asyncComponentDidMount() {
		await super.asyncComponentDidMount();

		const {fetchTimezonesAction} = this.props;
		
		this.executeAbortableAction(fetchTimezonesAction).then(options => this.setState({options}));
	}
	
	/** @inheritDoc */
	handleLocaleChange(translation) {
		const {fetchTimezonesAction} = this.props;
		
		return super.handleLocaleChange(translation)
			.then(res => 
				this.executeAbortableAction(fetchTimezonesAction).then(options => this.setState({options})).then(() => res)
			);
	}

	render() {
		const {key, readOnly, ...otherProps} = this.props;
		const {options} = this.state;
		
		return (
			!readOnly ?
				<SelectInput key={key} options={options} {...omit(otherProps, ['options'])} /> :
				<Label content={getStringForDisplay(getString(find(options, {value: this.props.value}), 'label'))} />
		);
	}
}

IoTimezoneSelectInput.propTypes = {
	...SelectInput.propTypes,

	// React key prop
	key: PropTypes.string,
	// Function to load options
	// @note If specified, 'labelStyle' and 'timezones' props will be ignored.
	loadOptions: PropTypes.func,
	// Flag that specifies if component is rendered in read-only mode where only the selected label will be rendered
	readOnly: PropTypes.bool,
};

export default connect(null, actions)(IoTimezoneSelectInput);